import { getMonthLabel } from "../../../common/util/period";
import { KpiSeries, KpiSeriesWithImage, NormalizedSeriesData, PY_MONTHS, SeriesPoint } from "./types";

export const normalizeSeriesData = (
  series?: KpiSeries[] | null,
  selectedKpis?: string[],
  selectedPerformanceYear?: number,
  locale?: string,
  endPeriod?: number,
  startPeriod?: number,
): NormalizedSeriesData[] => {
  if (!selectedKpis || selectedPerformanceYear === undefined) return [];

  const sortedSeries = [...(series ?? [])]
    .filter((s) => selectedKpis.includes(s.kpi))
    .sort((a, b) => selectedKpis.indexOf(a.kpi) - selectedKpis.indexOf(b.kpi));

  return PY_MONTHS.map((month) => ({
    month,
    monthLabel: getMonthLabel(month, selectedPerformanceYear, locale ?? "en-US"),
    values: selectedKpis.map((kpi) => {
      const s = sortedSeries.find((s) => s.kpi === kpi);
      const year = s?.years?.find((y) => y.performanceYear === selectedPerformanceYear);
      return {
        kpi,
        point: year?.points.find((p) => p.month === month) ?? null,
      };
    }),
  })).filter((row) => {
    const periodInt =
      row.month >= 9 ? (selectedPerformanceYear - 1) * 100 + row.month : selectedPerformanceYear * 100 + row.month;
    const isFuture = endPeriod !== undefined && periodInt > endPeriod;
    const hasData = row.values.some((v) => v.point !== null);
    return (startPeriod === undefined || periodInt >= startPeriod) && (isFuture || hasData);
  });
};

export type TransposedSeriesData = {
  kpi: string;
  values: { month: number; monthLabel: string; point: SeriesPoint | null }[];
};
export const transposeSeriesData = (
  normalizedRows: NormalizedSeriesData[],
  selectedKpis?: string[],
): TransposedSeriesData[] => {
  return (selectedKpis ?? []).map((kpi) => ({
    kpi,
    values: normalizedRows.map((row) => ({
      month: row.month,
      monthLabel: row.monthLabel,
      point: row.values.find((v) => v.kpi === kpi)?.point ?? null,
    })),
  }));
};

export const DECIMAL_KPIS = new Set([
  "personalPV",
  "groupPV",
  "leadershipPV",
  "rubyPV",
  "customerPV",
  "vcsPV",
  "personalVcsPercent",
  "performanceBonus",
]);

export const getSeriesPYs = (series?: KpiSeries[] | KpiSeriesWithImage[] | null) => {
  return new Set(
    series
      ?.filter((series) => series?.years !== null)
      .flatMap((series) => series!.years!.map((year) => year.performanceYear))
      .sort((a, b) => b - a),
  );
};
